import { configureStore } from '@reduxjs/toolkit';
import projectsSlice from './slices/projectsSlice';
import skillsSlice from './slices/skillsSlice';
import experienceSlice from './slices/experienceSlice';
import certificationsSlice from './slices/certificationsSlice';
import aboutSlice from './slices/aboutSlice';
import { persistenceMiddleware, loadPersistedState } from './middleware/persistenceMiddleware';

// Load persisted state
const preloadedState = loadPersistedState();

export const store = configureStore({
  reducer: {
    projects: projectsSlice,
    skills: skillsSlice,
    experience: experienceSlice,
    certifications: certificationsSlice,
    about: aboutSlice,
  },
  preloadedState,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/REHYDRATE'],
      },
    }).concat(persistenceMiddleware),
});

// Initialize state if this is the first time
if (!preloadedState) {
  console.log('No persisted state found, using initial state');
}

export default store; 